import React, { FC } from 'react';
import { Body } from '@edreamsodigeo/prisma-design-system';
import { isValid, format, parseISO } from 'date-fns';

type SegmentDateProps = {
  date: string;
  isSem?: boolean;
};

const SegmentDate: FC<SegmentDateProps> = ({ date, isSem }) => {
  const parsedDate = parseISO(date);
  const departureDateFormatted = isValid(parsedDate)
    ? format(parsedDate, 'E, d LLL')
    : '';

  return isSem ? (
    <Body type={'xSmall'} color="neutral.70">
      {departureDateFormatted}
    </Body>
  ) : null;
};

export default SegmentDate;
